import { Col, Collapse, Row, Table } from 'antd';
import React from 'react';
import './MobilePolicy.scss';

const dataSource = [
  {
    level: 'Mức 1 ',
    revenue: 'Từ 0 VNĐ đến 49.999.999 VNĐ',
    commission: '6%',
    commission_fly: '15.000 VNĐ/ vé',
  },
  {
    level: 'Mức 2 ',
    revenue: 'Từ 50.000.000 VNĐ đến 99.999.999 VNĐ',
    commission: '7%',
    commission_fly: '15.000 VNĐ/ vé',
  },
  {
    level: 'Mức 3 ',
    revenue: 'Từ 100.000.000 VNĐ đến 299.999.999 VNĐ',
    commission: '8%',
    commission_fly: '17.500 VNĐ/ vé',
  },
  {
    level: 'Mức 4',
    revenue: 'Từ 300.000.000 VNĐ trở lên',
    commission: '9%',
    commission_fly: '20.000 VNĐ/ vé',
  },
];

const columns = [
  {
    title: 'Mức',
    dataIndex: 'level',
    width: '100px',
  },
  {
    title: 'Doanh Thu một tháng ',
    dataIndex: 'revenue',
    width: '200px',
  },
  {
    title:
      'Hoa Hồng với phòng khách sạn (tỉ lệ phần trăm (%) dựa trên Doanh Thu của tất cả các Đơn Đặt Hàng Thành Công)',
    dataIndex: 'commission',
    width: '300px',
  },
  {
    title: 'Hoa Hồng với vé máy bay',
    dataIndex: 'commission_fly',
    width: '200px',
  },
];

const dataSourceComission = [
  {
    violate: 'Vi phạm lần đầu tiên',
    level_violate:
      '50% Hoa Hồng của tất cả các Đơn Đặt Hàng Thành Công phát sinh trong tháng có vi phạm.',
  },
  {
    violate: 'Vi phạm lần thứ hai',
    level_violate:
      '100% Hoa Hồng của tất cả các Đơn Đặt Hàng Thành Công phát sinh trong tháng có vi phạm.',
  },
  {
    violate: 'Vi phạm lần thứ ba',
    level_violate:
      '100% Hoa Hồng của tất cả các Đơn Đặt Hàng Thành Công phát sinh trong tháng có vi phạm. Đồng thời, VNTRAVEL sẽ khóa Tài Khoản Liên Kết và chấm dứt hợp tác với Đối Tác Liên Kết.',
  },
];
const columnsCommission = [
  {
    title: 'Vi phạm',
    dataIndex: 'violate',
  },
  {
    title: 'Mức phạt vi phạm và bồi thường thiệt hại',
    dataIndex: 'level_violate',
  },
];
const { Panel } = Collapse;
const MobilePolicy = (props) => {
  return (
    <div className='mobile-policy'>
      <div className='wrap'>
        <p style={{ textAlign: 'center' }} className='title-policy'>
          HỢP ĐỒNG TIẾP THỊ LIÊN KẾT
        </p>
        <p>
          Hợp đồng tiếp thị liên kết (“Hợp Đồng”) được lập bởi và giữa Công ty
          Cổ phần Du lịch Việt Nam VNTRAVEL, một công ty được thành lập và hoạt
          động theo quy định của pháp luật Việt Nam, có đăng ký doanh nghiệp số
          0108886908 do Sở Kế hoạch và Đầu tư thành phố Hà Nội cấp lần đầu ngày
          04 tháng 09 năm 2019 (“VNTRAVEL”), và cá nhân hoặc tổ chức như quy
          định tại Đơn Đăng Ký (“Đối Tác Liên Kết”).
        </p>
        <p>
          VNTRAVEL và Đối Tác Liên Kết được gọi riêng là “Bên” và được gọi chung
          là “Hai Bên”.
        </p>
        <Collapse defaultActiveKey={['']} expandIconPosition='right'>
          <Panel header='1. ĐỊNH NGHĨA' key='1'>
            <div className='content'>
              <Row>
                <Col span={24}>
                  <span>
                    Trong Hợp Đồng này, trừ khi ngữ cảnh yêu cầu khác, các từ
                    viết hoa sẽ có ý nghĩa như sau:
                  </span>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'>1.1 </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Hợp Đồng:</b> nghĩa là Hợp Đồng này, các phụ lục đính
                    kèm, các văn bản sửa đổi, bổ sung tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.2.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b> Hệ Thống Quản Lý:</b> nghĩa là trang web
                    doitac.mytour.vn hoặc trang web khác, thuộc quyền sở hữu,
                    quản lý của VNTRAVEL, và là địa chỉ để VNTRAVEL cung cấp cho
                    Đối Tác Liên Kết các Mã Khuyến Mại, Nội Dung Truyền Thông,
                    và Đường Dẫn.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.3.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b> Hệ Thống Đặt Hàng:</b> nghĩa là (các) trang web, ứng
                    dụng di động của VNTRAVEL hoặc các đối tác của VNTRAVEL nơi
                    Khách Hàng thực hiện đặt mua Sản Phẩm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.4.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b> Tài Khoản Liên Kết: </b> nghĩa là một tài khoản do
                    VNTRAVEL cung cấp cho Đối Tác Liên Kết trên Hệ Thống Quản
                    Lý.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.5.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b> Tài Khoản Liên Kết Đã Xác Thực: </b> nghĩa là Tài Khoản
                    Liên Kết đáp ứng các điều kiện của Đối Tác Liên Kết theo yêu
                    cầu của VNTRAVEL tại từng thời điểm và đã được VNTRAVEL xác
                    thực.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.6.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Trang Web Liên Kết:</b> nghĩa là trang web do Đối Tác
                    Liên Kết trực tiếp hoặc gián tiếp sở hữu, quản lý, điều
                    hành.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.7.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Khách Hàng:</b> nghĩa là các tổ chức, cá nhân đã truy cập
                    vào Trang Web Liên Kết và sau đó thực hiện đặt mua Sản Phẩm
                    trên Hệ Thống Đặt Hàng hoặc các tổ chức cá nhân thực hiện
                    đặt mua Sản Phẩm trên Hệ Thống Đặt Hàng và có sử dụng Mã
                    Khuyến Mại do VNTRAVEL cung cấp cho Đối Tác Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.8.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Dữ Liệu Khách Hàng: </b> nghĩa là tất cả các thông tin
                    liên quan tới Khách Hàng, bao gồm nhưng không giới hạn ở: họ
                    tên, địa chỉ, ngày tháng năm sinh, giới tính, số điện thoại,
                    số giấy chứng thực cá nhân, thông tin tài khoản ngân hàng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.9.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Sản phẩm: </b>nghĩa là vé máy bay, phòng khách sạn, tour,
                    vé tàu, vé xe, dịch vụ đặt mua các mặt hàng thực phẩm và
                    tiêu dùng, dịch vụ đặt bàn và các sản phẩm khác được
                    VNTRAVEL phân phối trên Hệ Thống Đặt Hàng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.10.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Đơn đặt hàng:</b>nghĩa là các yêu cầu của Khách Hàng đặt
                    mua Sản Phẩm trên Hệ Thống Đặt Hàng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.11.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Đơn đặt hàng thành công:</b> nghĩa là các Đơn Đặt Hàng
                    của Khách Hàng được thực hiện trên Hệ Thống Đặt Hàng mà có
                    sử dụng Mã Khuyến Mại hoặc Đường Dẫn.
                    <p style={{ marginBottom: 0 }}>
                      - Với vé máy bay: một Đơn Đặt Hàng Thành Công được hiểu là
                      Đơn Đặt Hàng mà Khách Hàng đã thanh toán thành công và
                      VNTRAVEL đã phát hành xác nhận vé máy bay cho Khách Hàng.
                    </p>
                    <p>
                      - Với phòng khách sạn: một Đơn Đặt Hàng Thành Công được
                      hiểu là Đơn Đặt Hàng mà Khách Hàng đã check-out.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.12.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Chương Trình Tiếp Thị Liên Kết:</b> nghĩa là chương trình
                    tiếp thị Sản Phẩm của VNTRAVEL, chương trình do VNTRAVEL vận
                    hành và Đối Tác Liên Kết sẽ thực hiện các công việc tiếp thị
                    để nhận được Hoa Hồng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.13.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Đối Tác Liên Kết:</b> nghĩa là các tổ chức, cá nhân đáp
                    ứng các Điều Kiện Tham Gia của Chương Trình Tiếp Thị Liên
                    Kết, đã cung cấp thông tin tại Đơn Đăng Ký trên Hệ Thống
                    Quản Lý, đã chấp thuận các điều khoản và điều kiện của Hợp
                    Đồng này, và được VNTRAVEL cung cấp Tài Khoản Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.14.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Điều Kiện Tham Gia:</b> nghĩa là các tiêu chuẩn mà Đối
                    Tác Liên Kết cần đáp ứng để tham gia Chương Trình Tiếp Thị
                    Liên Kết do VNTRAVEL quy định tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.15.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Đơn Đăng Ký:</b> nghĩa là yêu cầu của bất kỳ tổ chức, cá
                    nhân nào để trở thành Đối Tác Liên Kết. Các tổ chức, cá nhân
                    cung cấp thông tin tại Đơn Đăng Ký trên Hệ Thống Quản Lý
                    theo yêu cầu của VNTRAVEL tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.16.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Đường Dẫn:</b> nghĩa là bất kỳ biểu tượng, đồ họa, văn
                    bản nào được nhúng vào một trang web hoặc email mà có chứa
                    một con trỏ siêu văn bản dẫn đến địa chỉ URL của VNTRAVEL và
                    được đặt trên Trang Web Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.17.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Mã Khuyến Mãi:</b> nghĩa là một mã bao gồm (các) số
                    và/hoặc chữ do VNTRAVEL cung cấp cho Đối Tác Liên Kết trên
                    Hệ Thống Quản Lý để Đối Tác Liên Kết cung cấp cho các Khách
                    Hàng của mình khi Khách Hàng thực hiện đặt mua Sản Phẩm trên
                    Hệ Thống Đặt Hàng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.18.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Nội Dung Truyền Thông:</b> nghĩa là bất kỳ nội dung,
                    thông tin, mã (bao gồm cả Mã Khuyến Mại), công cụ, hình ảnh
                    do VNTRAVEL cung cấp cho Đối Tác Liên Kết nhằm mục đích thực
                    hiện Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.19.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Hoa Hồng:</b> nghĩa là khoản tiền mà Đối Tác Liên Kết
                    được nhận từ kết quả của việc thực hiện Chương Trình Tiếp
                    Thị Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.20.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Doanh Thu:</b> nghĩa là tổng giá trị của các Đơn Đặt Hàng
                    Thành Công trên Hệ Thống Đặt Hàng mỗi tháng. Doanh Thu được
                    dùng để tính Hoa Hồng là giá trị của các Đơn Đặt Hàng Thành
                    Công đã bao gồm VAT
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.21.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Thời Gian Lưu Cookie:</b> nghĩa là thời gian lưu dữ liệu
                    của Khách Hàng truy cập qua Đường Dẫn/ Trang Web Liên Kết
                    của Đối Tác Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.22.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Thuế:</b> nghĩa là tất cả các loại thuế, các khoản thu,
                    khoản áp tính hoặc các khoản tương tự và mức được áp tính,
                    áp dụng hoặc thi hành bởi cơ quan có thẩm quyền và bất kỳ
                    khoản lãi, phạt, phụ phí hoặc phụ thu nào có liên quan.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.23.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Thông Tin Bảo Mật:</b> là mọi thông tin mà mỗi Bên có
                    được liên quan tới việc đàm phán, thực hiện Hợp Đồng này,
                    bao gồm các số liệu, dữ liệu, cơ sở dữ liệu, phân tích,
                    thông tin về các giao dịch, tài khoản, thông tin cá nhân của
                    Khách Hàng, bí mật kinh doanh được chứa đựng dưới bất kỳ
                    định dạng hoặc phương tiện truyền thông nào (bằng lời nói
                    hoặc văn bản) và trong hoạt động kinh doanh thông thường,
                    không cần thiết phải được lưu ý hoặc thông báo với người
                    nhận là thông tin bảo mật, sẽ được xem là có tính bảo mật.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 1.24.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Quyền Sở Hữu Trí Tuệ:</b> là (i) quyền đối với các bằng
                    sáng chế, nhãn hiệu, nhãn hiệu thương mại, nhãn hiệu dịch
                    vụ, bí quyết, sáng chế, thiết kế, bí mật kinh doanh, tên
                    thương mại và tên doanh nghiệp, tên miền internet; (ii)
                    quyền đối với phần mềm, tác phẩm hoặc quyền tác giả và quyền
                    liên quan đến quyền đối với tác phẩm hoặc quyền tác giả,
                    thông số kỹ thuật, thiết kế, phân tích, quy trình, phương
                    pháp, tài liệu, báo cáo, bản vẽ và sản phẩm công việc; (iii)
                    quyền đối với dữ liệu; (iv) quyền đối với các hệ thống trang
                    web, ứng dụng (cho dù đã đăng ký, có thể được đăng ký hoặc
                    chưa đăng ký) ở bất kỳ quốc gia nào và dưới bất kỳ hình
                    thức, phương tiện, hoặc công nghệ nào được biết đến hoặc
                    phát triển sau này, cho dù hữu hình hay vô hình; (v) quyền
                    đối với Dữ Liệu Khách Hàng.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='2. CHƯƠNG TRÌNH TIẾP THỊ LIÊN KẾT' key='2'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 2.1.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    <b>Chương Trình Tiếp Thị Liên Kết không độc quyền</b>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL tại đây đề nghị và Đối Tác Liên Kết đồng ý tham gia
                    Chương Trình Tiếp Thị Liên Kết không độc quyền. Theo đó, Đối
                    Tác Liên Kết sẽ thực hiện quảng cáo, giới thiệu Sản Phẩm của
                    VNTRAVEL trên Trang Web Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Phụ thuộc vào kết quả thực hiện Chương Trình Tiếp Thị Liên
                    Kết, VNTRAVEL sẽ trả Hoa Hồng cho Đối Tác Liên Kết theo quy
                    định tại Điều 3.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 2.2. </div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    <b>Chăm sóc Khách Hàng</b>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL sẽ thực hiện các hoạt động chăm sóc Khách Hàng theo
                    chính sách của VNTRAVEL đã được công bố trên Hệ Thống Đặt
                    Hàng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ không thực hiện hoạt động chăm sóc Khách
                    Hàng. Trong trường hợp, Khách Hàng có câu hỏi, thắc mắc liên
                    quan đến Sản Phẩm, Đối Tác Liên Kết sẽ chuyển các yêu cầu
                    này tới bộ phận chăm sóc Khách Hàng và/hoặc bộ phận quản lý
                    Chương Trình Tiếp Thị Liên Kết của VNTRAVEL tại địa chỉ
                    email
                    <a href='mailto:hotro@mytour.vn'> hotro@mytour.vn.</a>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 2.3.</div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    <b>Đường Dẫn, Mã Khuyến Mại và Nội Dung Truyền Thông</b>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL sẽ cung cấp cho Đối Tác Liên Kết (các) Đường Dẫn,
                    Mã Khuyến Mại và Nội Dung Truyền Thông. Bằng chi phí của
                    mình, Đối Tác Liên Kết sẽ kết nối, hiển thị Đường Dẫn, Mã
                    Khuyến Mại và Nội Dung Truyền Thông lên Trang Web Liên Kết,
                    đảm bảo Khách Hàng có thể tiếp cận được Đường Dẫn, Mã Khuyến
                    Mại và Nội Dung Truyền Thông.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết chỉ được sử dụng Đường Dẫn, Mã Khuyến Mại
                    và Nội Dung Truyền Thông phù hợp với các quy định của pháp
                    luật và Hợp Đồng này, với mục đích duy nhất là thực hiện
                    Chương Trình Tiếp Thị Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> c)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết chỉ được phép chuyển giao, phân phối lại
                    Đường Dẫn, Mã Khuyến Mại và Nội Dung Truyền Thông vì mục
                    đích thực hiện Chương Trình Tiếp Thị Liên Kết. Đối Tác Liên
                    Kết phải đảm bảo bên thứ ba không được sử dụng Đường Dẫn, Mã
                    Khuyến Mại và Nội Dung Truyền Thông để thực hiện những hành
                    vi có tác động tiêu cực tới VNTRAVEL. Bằng chi phí của mình,
                    Đối Tác Liên Kết chịu trách nhiệm về việc bên thứ ba sử dụng
                    Đường Dẫn, Mã Khuyến Mại và Nội Dung Truyền Thông.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 2.4</div>
                </Col>
                <Col span={21}>
                  <div className='right'>Điều Kiện Tham Gia</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không phụ thuộc vào các quy định khác tại Hợp Đồng này, một
                    Tài Khoản Liên Kết Đã Xác Thực phải đáp ứng các Điều Kiện
                    Tham Gia như dưới đây:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    (i)
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Yêu cầu về tài khoản mạng xã hội:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết phải có ít nhất 01 (một) mạng xã hội có từ
                    5000 (năm nghìn) người theo dõi (followers) trở lên; và/hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết có một website có từ 10.000 (mười nghìn)
                    lượt truy cập mỗi tháng trở lên; và/hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết có một kênh Youtube có từ 2500 (hai nghìn
                    năm trăm) người theo dõi trở lên và có ít nhất 02 video đạt
                    từ 200.000 (hai trăm nghìn) lượt xem/ 01 video trở lên;
                    và/hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết một kênh Tiktok có từ 4000 (bốn nghìn)
                    người theo dõi trở lên; và/hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết đạt hơn 5000 (năm nghìn) điểm Follower
                    Scores khi cộng lượt người theo dõi tối đa 02 (hai) kênh
                    mạng xã hội của mình. Công cụ tính điểm tại đường dẫn:
                    <a href='https://bitly.com.vn/ucaouw'>
                      https://bitly.com.vn/ucaouw
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    (ii)
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Yêu cầu về lượt tương tác: Đối Tác Liên Kết có 10 (mười) bài
                    viết gần nhất tính đến ngày xác thực có từ 1% tương tác trở
                    lên. Căn cứ tính % (phần trăm) tương tác là: số lượt tương
                    tác/ 1 bài/ tổng số lượt theo dõi của Trang Web Liên Kết.
                    Lượt tương tác được định nghĩa là tổng số lượng người dùng
                    chọn “thích”, số lượng bình luận và số lượng chia sẻ trên
                    một bài viết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Một Tài Khoản Liên Kết đáp ứng các Điều Kiện Tham Gia sẽ trở
                    thành Tài Khoản Liên Kết Đã Xác Thực.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>c)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không phụ thuộc vào các quy định khác tại Hợp Đồng này,
                    VNTRAVEL có quyền tuy nghi chỉnh sửa, thay đổi Điều Kiện
                    Tham Gia tại bất kỳ thời điểm nào. Theo đó, VNTRAVEL có
                    quyền thay đổi tình trạng tài khoản của Đối Tác Liên Kết phù
                    hợp với các Điều Kiện Tham Gia mới.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 2.5</div>
                </Col>
                <Col span={21}>
                  <div className='right'>Tài Khoản Liên Kết </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết có trách nhiệm đảm bảo các Đường Dẫn được
                    sử dụng trên Trang Web Liên Kết đã bao gồm thông tin về Tài
                    Khoản Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết hiểu và đồng ý rằng:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    (i)
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Việc loại bỏ hoặc thay đổi thông tin Tài Khoản Liên Kết trên
                    Đường Dẫn có thể ảnh hưởng tới Hoa Hồng của Đối Tác Liên
                    Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    (ii)
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL không có trách nhiệm thanh toán Hoa Hồng cho những
                    Đơn Đặt Hàng của Khách Hàng xuất phát từ những Đường Dẫn có
                    thông tin Tài Khoản Liên Kết không đúng và/hoặc không đầy
                    đủ.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 2.6</div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    Quy định về hoạt động tiếp thị liên kết
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> a) </div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    <b>Từ khóa</b>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết không được thực hiện Chương Trình Tiếp Thị
                    Liên Kết dưới bất kỳ hình thức nào, mà nội dung tiếp thị
                    liên kết có đề cập đến các Quyền Sở Hữu Trí Tuệ, bao gồm
                    nhưng không giới hạn ở các hành vi dưới đây:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Sử dụng từ khóa là tên các nhãn hiệu của VNTRAVEL khi thực
                    hiện các chiến dịch quảng cáo trên các công cụ tìm kiếm
                    (Google, Adwords, Cốc Cốc …); và/hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Sử dụng tên các nhãn hiệu của VNTRAVEL khi xây dựng các
                    trang web; thành lập các nhóm hoặc các trang (page,
                    fanpage…) trên mạng xã hội; và/hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Sử dụng tên các nhãn hiệu của VNTRAVEL trong tiêu đề, mô tả,
                    đường dẫn (link) hiển thị trên các quảng cáo tìm kiếm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Tên nhãn hiệu của VNTRAVEL bao gồm nhưng không giới hạn ở:
                    Mytour, Tripi, Dinogo, Mytable, Myfresh.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    Các quy định khác liên quan đến hoạt động tiếp thị liên kết
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'></div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết không được thực hiện bất kỳ hành động nào
                    vi phạm các quy định của pháp luật liên quan đến tiếp thị
                    liên kết, vi phạm quy định của các đơn vị cung cấp công cụ
                    tìm kiếm và các quy định khác của VNTRAVEL quy định tại Hợp
                    Đồng này, bao gồm nhưng không giới hạn ở:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Thực hiện bất kỳ hành động nào nhằm chống lại/ đi ngược lại
                    các nguyên tắc của các công cụ tìm kiếm, lợi dụng các lỗ
                    hổng của công cụ tìm kiếm để đạt thứ hạng cao;
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Lừa dối, ép buộc Khách Hàng truy cập vào Đường Dẫn và thực
                    hiện Đơn Đặt Hàng;
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Giả mạo VNTRAVEL hoặc cung cấp thông tin sai lệch nhằm tiếp
                    cận Khách Hàng;
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iv)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Sử dụng Đường Dẫn và/hoặc Chương Trình Tiếp Thị Liên Kết để
                    lừa dối Khách Hàng nhằm thực hiện bất kỳ mục đích nào khác
                    (ngoài mục đích tiếp thị Sản Phẩm của VNTRAVEL);
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (v)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Thực hiện hoạt động tiếp thị liên kết trên các Trang Web
                    Liên Kết có nội dung vi phạm pháp luật, vi phạm đạo đức;
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (vi)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Cung cấp thông tin Sản Phẩm và/hoặc thông tin của VNTRAVEL
                    cho Khách Hàng không đầy đủ, gây ảnh hưởng tiêu cực đến các
                    Quyền Sở Hữu Trí Tuệ.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(vii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Cung cấp thông tin không đúng, không đầy đủ về mối quan hệ
                    của Đối Tác Liên Kết và VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(viii) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Sử dụng logo, tên thương hiệu, các hình ảnh thuộc Hệ Thống
                    Quản Lý, Hệ Thống Bán Hàng của VNTRAVEL, các Quyền Sở Hữu
                    Trí Tuệ cho bất kỳ mục đích nào khác ngoài mục đích tiếp thị
                    Sản Phẩm của VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(ix) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Sử dụng phần mềm, kỹ thuật máy tính nhằm tác động trái phép
                    đến Hệ Thống Quản Lý, Hệ Thống Đặt Hàng và thay đổi kết quả
                    của Chương Trình Tiếp Thị Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='3. HOA HỒNG' key='3'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 3.1</div>
                </Col>
                <Col span={21}>
                  <div className='right'>Mức hoa hồng</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col>
                  <div className='left-normal'></div>
                </Col>
                <Col span={24}>
                  <div className='right-normal'>
                    Phụ thuộc vào các điều kiện và nguyên tắc tính Hoa Hồng, nếu
                    Khách Hàng của Đối Tác Liên Kết đặt mua Sản Phẩm trên Hệ
                    Thống Đặt Hàng và có Đơn Đặt Hàng Thành Công, VNTRAVEL sẽ
                    thanh toán Hoa Hồng cho Đối Tác Liên Kết như sau:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={24}>
                  {props.content}
                  Mức hoa hồng nêu trên đã bao gồm VAT
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'>3.2. </div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    Điều kiện và nguyên tắc tính Hoa Hồng
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={24}>
                  <div className='right-normal'>
                    Doanh Thu và Hoa Hồng mà Đối Tác Liên Kết nhận được phụ
                    thuộc vào các điều kiện và nguyên tắc sau:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL sẽ ghi nhận Doanh Thu và tính Hoa Hồng cho Đối Tác
                    Liên Kết dựa trên các điều kiện sau:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Khách Hàng sử dụng Mã Khuyến Mại mà VNTRAVEL cung cấp cho
                    Đối Tác Liên Kết thông qua Hệ Thống Quản Lý để thực hiện
                    việc đặt mua Sản Phẩm trên Hệ Thống Đặt Hàng; hoặc Khách
                    Hàng sử dụng Đường Dẫn của Đối Tác Liên Kết để đặt mua Sản
                    Phẩm trên Hệ Thống Đặt Hàng; và
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Chỉ tính Hoa Hồng cho các Đơn Đặt Hàng Thành Công; và
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Các Đơn Đặt Hàng Thành Công không vi phạm quy định về quảng
                    cáo quy định tại Hợp Đồng này; và
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(iv)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết không vi phạm các nghĩa vụ khác được quy
                    định tại Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Các nguyên tắc tính Doanh Thu và Hoa Hồng
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nguyên tắc ưu tiên Đường Dẫn
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nếu Khách Hàng sử dụng Mã Khuyến Mại của một Đối Tác Liên
                    Kết, nhưng thực hiện Đơn Đặt Hàng thông qua Đường Dẫn của
                    một Đối Tác Liên Kết khác, thì Đơn Đặt Hàng Thành Công sẽ
                    được ghi nhận là Doanh Thu của Đối Tác Liên Kết mà Khách
                    Hàng đã sử dụng Đường Dẫn.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nguyên tắc nhấp chuột cuối cùng (last click)
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nếu Khách Hàng nhấp chuột (click) vào nhiều Đường Dẫn/ Trang
                    Web Liên Kết của các Đối Tác Liên Kết khác nhau thì VNTRAVEL
                    sẽ ghi nhận Doanh Thu và tính Hoa Hồng cho Đối Tác Liên Kết
                    mà Khách Hàng đã truy cập Đường Dẫn/ Trang Web Liên Kết lần
                    cuối cùng trước khi có Đơn Đặt Hàng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nguyên tắc Thời Gian Lưu Cookie 30 ngày.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Bất kỳ Đơn Đặt Hàng nào của Khách Hàng (dù là thông qua
                    Đường Dẫn/ Trang Web Liên Kết của Đối Tác Liên Kết hoặc trực
                    tiếp truy cập vào Hệ Thống Đặt hàng để thực hiện Đơn Đặt
                    Hàng) trong vòng 30 ngày kể từ ngày cuối cùng Khách Hàng
                    nhấp chuột (click) vào Đường Dẫn/ Trang Web Liên Kết của Đối
                    Tác Liên Kết, đều được ghi nhận là Doanh Thu và là căn cứ để
                    tính Hoa Hồng cho Đối Tác Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(iv)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nguyên tắc ưu tiên sử dụng Hệ Thống Quản Lý, Hệ Thống Đặt
                    Hàng của VNTRAVEL khi tính Doanh Thu và Hoa Hồng. Quyết định
                    của Vntravel dựa trên dữ liệu từ Hệ Thống Đặt Hàng và Hệ
                    Thống Quản Lý là cuối cùng và có giá trị pháp lý ràng buộc
                    Hai Bên.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(v)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nguyên tắc chỉ thanh toán Hoa Hồng cho các Tài Khoản Liên
                    Kết Đã Xác Thực. Không phụ thuộc vào các quy định khác tại
                    Hợp Đồng này, VNTRAVEL chỉ thanh toán Hoa Hồng cho các Tài
                    Khoản Liên Kết Đã Xác Thực tại thời điểm thanh toán.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='4. THANH TOÁN' key='4'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 4.1</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>Tính Doanh Thu và Hoa Hồng</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                {/* <Col span={3}>
                  <div className='left'> </div>
                </Col> */}
                <Col span={24}>
                  <div className='right-normal'>
                    VNTRAVEL sẽ tính Doanh Thu và Hoa Hồng mà Đối Tác Liên Kết
                    nhận được mỗi tháng. Trong vòng 10 ngày làm việc đầu tiên
                    của tháng N+1, VNTRAVEL sẽ gửi Đối Tác Liên Kết kết quả
                    Doanh Thu và Hoa Hồng mà Đối Tác Liên Kết nhận được trong
                    tháng N thông qua email mà Đối Tác Liên Kết đã cung cấp tại
                    Đơn Đăng Ký và/hoặc thông qua Tài Khoản Liên Kết trên Hệ
                    Thống Quản Lý.
                    <br /> Đối Tác Liên Kết có trách nhiệm kiểm tra email và Tài
                    Khoản Liên Kết để cập nhật kết quả Doanh Thu và Hoa Hồng.
                    <br />
                    Các bên đồng ý rằng dữ liệu do VNTRAVEL gửi là dữ liệu gốc
                    và được dùng làm căn cứ thanh toán.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 4.2</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>Thanh toán</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Thời gian thanh toán: VNTRAVEL có trách nhiệm thanh toán Hoa
                    Hồng cho Đối Tác Liên Kết trong vòng 30 ngày kể từ ngày có
                    đầy đủ hồ sơ thanh toán hợp lệ.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Hồ sơ thanh toán hợp lệ gồm:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    (i)
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Với Đối Tác Liên Kết là cá nhân:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'right' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal' style={{ marginLeft: '1%' }}>
                    Thông tin chứng minh nhân dân/ căn cước công dân của người
                    nhận thanh toán.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'right' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal' style={{ marginLeft: '1%' }}>
                    Thông tin tài khoản nhận thanh toán. Để làm rõ, thông tin
                    của chủ tài khoản nhận thanh toán phải trùng khớp với thông
                    tin trên chứng minh nhân dân/căn cước công dân.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'right' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal' style={{ marginLeft: '1%' }}>
                    Các thông tin khác theo yêu cầu của VNTRAVEL trên Hệ Thống
                    Quản Lý mà VNTRAVEL xét thấy cần thiết để thực hiện thanh
                    toán
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'center' }}>
                    (ii)
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết là tổ chức
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'right' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal' style={{ marginLeft: '1%' }}>
                    Hóa đơn tài chính hợp lệ của Đối Tác Liên Kết phát hành cho
                    VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'right' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal' style={{ marginLeft: '1%' }}>
                    Thông tin tài khoản nhận thanh toán. Để làm rõ, chủ tài
                    khoản nhận thanh toán phải là tổ chức phát hành hóa đơn tài
                    chính cho VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal' style={{ textAlign: 'right' }}>
                    •
                  </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal' style={{ marginLeft: '1%' }}>
                    Các thông tin khác theo yêu cầu của VNTRAVEL trên Hệ Thống
                    Quản Lý mà VNTRAVEL xét thấy cần thiết để thực hiện thanh
                    toán.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> c)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Hình thức thanh toán: VNTRAVEL sẽ thực hiện chuyển khoản
                    bằng đồng Việt Nam theo thông tin tài khoản Đối Tác Liên Kết
                    cập nhật trên Hệ Thống Quản Lý. Nếu có thay đổi thông tin
                    nhận thanh toán, Đối Tác Liên Kết cần cập nhật các thông tin
                    này trước 00:00:00 giờ ngày 25 hàng tháng tháng. VNTRAVEL
                    không chịu trách nhiệm nếu những cập nhật này được thực hiện
                    sau thời gian nêu trên.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> d)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>Điều kiện thanh toán:</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> d)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không phụ thuộc vào quy định về thời gian thanh toán nêu
                    trên, VNTRAVEL chỉ có trách nhiệm thanh toán Hoa Hồng khi
                    các điều kiện sau được thỏa mãn:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết đạt mức Hoa Hồng tối thiểu là 50.000 VNĐ/ 1
                    tháng (bằng chữ: năm mươi nghìn đồng). Để làm rõ, nếu Đối
                    Tác Liên Kết không đạt mức Hoa Hồng tối thiểu 50.000 VNĐ/ 1
                    tháng thì VNTRAVEL không có trách nhiệm thanh toán Hoa Hồng
                    của tháng đó cho Đối Tác Liên Kết. Số tiền Hoa Hồng của các
                    tháng không được tích lũy và cộng dồn. Ví dụ, vào tháng N,
                    Đối Tác Liên Kết đạt 40.000 VNĐ tiền Hoa Hồng, VNTRAVEL sẽ
                    không có trách nhiệm thanh toán số tiền Hoa Hồng này cho Đối
                    Tác Liên Kết và số tiền Hoa Hồng này cũng không được tích
                    lũy, cộng dồn vào các tháng sau; và
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Tên của tài khoản nhận thanh toán Hoa Hồng trùng với tên
                    trên chứng minh nhân dân/căn cước công dân; và
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>(ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Số điện thoại và/hoặc email của Tài Khoản Liên Kết phải
                    trùng với số điện thoại và/hoặc email của trang mạng xã hội,
                    website, kênh youtube, kênh Tiktok.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 4.3.</div>
                </Col>
                <Col span={21}>
                  <div className='right'>Thuế</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ chịu trách nhiệm thanh toán các khoản
                    Thuế (bao gồm những không giới hạn ở thuế thu nhập cá nhân)
                    theo quy định của pháp luật liên quan đến thu nhập của Đối
                    Tác Liên Kết phát sinh từ việc thực hiện Hợp Đồng này. Đối
                    Tác Liên Kết đồng ý miễn trừ VNTRAVEL khỏi bất kỳ trách
                    nhiệm nào liên quan đến nghĩa vụ nộp thuế của Đối Tác Liên
                    Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'>b) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Trong trường hợp Đối Tác Liên Kết là cá nhân, Đối Tác Liên
                    Kết đồng ý để VNTRAVEL cấn trừ thuế thu nhập cá nhân trước
                    khi thực hiện thanh toán Hoa Hồng và Đối Tác Liên Kết sẽ
                    cung cấp các thông tin cần thiết cho VNTRAVEL để thực hiện
                    việc nộp thuế thu nhập cá nhân.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='5. QUYỀN VÀ NGHĨA VỤ CỦA HAI BÊN' key='5'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 5.1. </div>
                </Col>
                <Col span={21}>
                  <div className='right'>
                    Quyền và nghĩa vụ của Đối Tác Liên Kết
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ được nhận Hoa Hồng phù hợp với điều
                    khoản và điều kiện tại Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết được VNTRAVEL hỗ trợ đào tạo về Sản Phẩm,
                    Hệ Thống Quản Lý và Hệ Thống Đặt Hàng tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> c) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết đảm bảo quyền sở hữu và sử dụng hợp pháp
                    Trang Web Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> d) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết có trách nhiệm bảo mật thông tin Tài Khoản
                    Liên Kết, và phải ngay lập tức thông báo cho VNTRAVEL nếu
                    Đối Tác Liên Kết phát hiện bất kỳ hành vi đăng nhập, sử dụng
                    trái phép Tài Khoản Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> e)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ sử dụng nỗ lực hợp lý để sửa chữa những
                    lỗi liên quan đến Trang Web Liên Kết, Mã Khuyến Mại, Nội
                    Dung Truyền Thông mà VNTRAVEL thông báo cho Đối Tác Liên Kết
                    tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> f) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ sử dụng nỗ lực hợp lý để sửa chữa những
                    lỗi liên quan đến Trang Web Liên Kết, Mã Khuyến Mại, Nội
                    Dung Truyền Thông mà VNTRAVEL thông báo cho Đối Tác Liên Kết
                    tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> g)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ không thực hiện bất kỳ hành vi nào có
                    thể ảnh hưởng tiêu cực tới VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> h)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết sẽ tôn trọng các Quyền Sở Hữu Trí Tuệ của
                    VNTRAVEL và không thực hiện bất kỳ hành vi nào có thể ảnh
                    hưởng đến Quyền Sở Hữu Trí Tuệ của VNTRAVEL bao gồm nhưng
                    không giới hạn ở: sao chép, dịch ngược, mô phỏng một phần
                    hoặc toàn bộ Quyền Sở Hữu Trí Tuệ. Không quy định nào trong
                    Hợp Đồng này được hiểu là VNTRAVEL chuyển giao, chuyển
                    nhượng, cho phép Đối Tác Liên Kết sử dụng Quyền Sở Hữu Trí
                    Tuệ dưới bất kỳ hình thức nào, trừ khi được quy định khác đi
                    trong Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết có trách nhiệm nộp Thuế phát sinh từ Hoa
                    Hồng mà Đối Tác Liên Kết nhận được, trừ trường hợp Đối Tác
                    Liên Kết đã ủy quyền cho VNTRAVEL nộp thuế thu nhập cá nhân
                    theo quy định tại Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> j)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đối Tác Liên Kết đảm bảo các thông tin cung cấp cho VNTRAVEL
                    tại Đơn Đăng Ký và Hệ Thống Quản Lý là đúng và đầy đủ. Bằng
                    chi phí của mình, Đối Tác Liên Kết sẽ giải quyết tất cả các
                    khiếu nại, khiếu kiện, tranh chấp liên quan đến thông tin do
                    Đối Tác Liên Kết cung cấp cho VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 5.2.</div>
                </Col>
                <Col span={21}>
                  <div className='right'>Quyền và nghĩa vụ của VNTRAVEL</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Chịu trách nhiệm tính Doanh Thu và trả Hoa Hồng cho Đối Tác
                    Liên Kết phù hợp với điều khoản và điều kiện tại Hợp Đồng
                    này. Quyết định của VNTRAVEL về Doanh Thu và Hoa Hồng dựa
                    trên dữ liệu từ Hệ Thống Quản Lý và Hệ Thống Đặt Hàng là
                    cuối cùng và có giá trị áp dụng với cả Hai Bên.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Cung cấp cho Đối Tác Liên Kết thông tin về Sản Phẩm, Quyền
                    Sở Hữu Trí Tuệ, Mã Khuyến Mại, Nội Dung Truyền Thông tại
                    từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> c)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Quyết định các nội dung của Chương Trình Tiếp Thị Liên Kết
                    và thông báo cho Đối Tác Liên Kết trước khi áp dụng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> d) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Chịu trách nhiệm nộp thuế thu nhập cá nhân cho Đối Tác Liên
                    Kết theo thỏa thuận của Hai Bên tại Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='6. BỒI THƯỜNG THIỆT HẠI VÀ PHẠT VI PHẠM' key='6'>
            <div className='content'>
              <Row>
                <Col span={24}>
                  <div className='right-normal'>
                    Trong trường hợp Đối Tác Liên Kết vi phạm các quy định của
                    Chương Trình Tiếp Thị Liên Kết, và các nghĩa vụ khác của Hợp
                    Đồng này, Đối Tác Liên Kết đồng ý chịu phạt vi phạm và bồi
                    thường thiệt hại như sau:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                {/* <Col span={3}>
                  <div className='left'></div>
                </Col> */}
                <Col span={24}>
                  <div className='right-normal'>
                    <Table
                      dataSource={dataSourceComission}
                      columns={columnsCommission}
                      pagination={false}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='7. BẢO MẬT THÔNG TIN' key='7'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'>7.1</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Mỗi Bên <b>(“Bên Nhận Thông Tin”)</b> cam kết giữ và kiểm
                    soát tất cả các Thông Tin Bảo Mật được cung cấp bởi bên kia
                    <b>(“Bên Cung Cấp Thông Tin”)</b> trong sự bảo mật chặt chẽ
                    và không tiết lộ thông tin này cho bất kỳ bên thứ ba nào trừ
                    trường hợp được Bên Cung Cấp Thông Tin đồng ý trước bằng văn
                    bản.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'>7.2.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Bên Nhận Thông Tin phải đảm bảo các giám đốc, cổ đông, nhân
                    viên quản lý cấp cao, nhà tư vấn, người lao động, Nhà Thầu
                    Phụ và các đại lý của mình sẽ chỉ sử dụng các Thông Tin Bảo
                    Mật được cung cấp bởi Bên kia, trên cơ sở “Cần phải biết” vì
                    mục đích của Hợp Đồng, và phải được nhận biết về các yêu cầu
                    bảo mật liên quan tới thông tin được quy định tại Điều này.
                    Bên Nhận Thông Tin phải đảm bảo rằng người lao động, Nhà
                    Thầu Phụ và các đại lý của mình bảo mật các Thông Tin Bảo
                    Mật, bao gồm nhưng không giới hạn việc phải ký kết một thỏa
                    thuận bảo mật với một hoặc cả Hai Bên Cung Cấp Thông Tin và
                    Bên Nhận Thông Tin. Bên Cung Cấp Thông Tin có thể yêu cầu
                    Bên Nhận Thông Tin xác nhận việc tuân thủ điều khoản này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'>7.3.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không ảnh hưởng tới các quyền khác của Bên Cung Cấp Thông
                    Tin, trong trường hợp có sự tiết lộ hoặc sử dụng trái phép
                    Thông Tin Bảo Mật xảy ra bởi sự tiết lộ của Bên Nhận Thông
                    Tin thì Bên đó phải sử dụng các nỗ lực hợp lý để hỗ trợ Bên
                    Cung Cấp Thông Tin trong việc khôi phục và ngăn chặn việc sử
                    dụng, phổ biến, bán hoặc các định đoạt khác đối với Thông
                    Tin Bảo Mật.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 7.4.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Các điều khoản tại Điều này sẽ không hạn chế Bên Nhận Thông
                    Tin tiết lộ các thông tin đó nếu có thể chứng minh rằng các
                    thông tin này:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đã thuộc sở hữu của mình (với đầy đủ quyền để tiết lộ) trước
                    thời điểm được nhận các thông tin đó từ Bên Cung Cấp Thông
                    Tin; hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đã trở nên công khai tại thời điểm tiết lộ mà không xuất
                    phát từ bất kỳ sự vi phạm nghĩa vụ của Bên Nhận Thông Tin;
                    hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iii) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đã được phát triển độc lập bởi các Nhân viên của Bên Nhận
                    Thông Tin, người mà không tiếp cận các Thông Tin Bảo Mật;
                    hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (iv)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Đã được cung cấp từ một Bên được tự do tiết lộ thông tin thứ
                    ba; hoặc
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (v)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Được Bên Cung Cấp Thông Tin cho phép tiết lộ thông tin bằng
                    văn bản.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 7.5.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Bên Nhận Thông Tin được phép tiết lộ thông tin theo yêu cầu
                    của pháp luật, Tòa án hoặc cơ quan nhà nước có thẩm quyền,
                    với điều kiện Bên Nhận Thông Tin phải ngay lập tức thông báo
                    cho Bên Cung Cấp Thông Tin bằng văn bản việc tiết lộ này và
                    Bên Nhận Thông Tin, trong trường hợp thời gian cho phép,
                    phải hợp tác với Bên Cung Cấp Thông Tin để bảo đảm việc tiết
                    lộ thông tin là tối thiểu và không ảnh hưởng bất lợi cho Bên
                    Cung Cấp Thông Tin.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 7.6.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Các quy định tại Điều này sẽ không bị chấm dứt và sẽ tiếp
                    tục có hiệu lực sau Thời Hạn hoặc sau thời điểm chấm dứt Hợp
                    Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='8. BẤT KHẢ KHÁNG' key='8'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 8.1</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Trong Hợp Đồng này, sự kiện bất khả kháng được hiểu là những
                    sự kiện xảy ra một cách khách quan, không thể lường trước
                    được và nằm ngoài tầm kiểm soát của Hai Bên (bao gồm, nhưng
                    không giới hạn động đất, lũ lụt, hạn hán, cháy, nổ, dịch
                    bệnh, thảm họa, thiên tai, chiến tranh, khủng bố, đình công,
                    phá sản, hacker,…), mặc dù Hai Bên đã cố gắng hết sức để
                    ngăn cản, hạn chế và sự kiện này là nguyên nhân trực tiếp
                    ảnh hưởng tới việc thực hiện Hợp Đồng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 8.2</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Khi xảy ra sự kiện bất khả kháng, Bên bị ảnh hưởng bởi sự
                    kiện bất khả kháng phải kịp thời thông báo bằng văn bản cho
                    Bên còn lại trong vòng 72 (bảy mươi hai) giờ kể từ ngày xảy
                    ra sự kiện bất khả kháng. Trong khoảng thời gian không thể
                    thực hiện Hợp Đồng do sự kiện bất khả kháng, Hai Bên vẫn
                    phải tiếp tục thực hiện các nghĩa vụ Hợp Đồng của mình theo
                    hoàn cảnh thực tế cho phép và phải tích cực, chủ động tìm
                    mọi biện pháp hợp lý để thực hiện phần việc không bị ảnh
                    hưởng bởi sự kiện bất khả kháng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 8.3. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Một Bên không hoàn thành nhiệm vụ của mình do trường hợp bất
                    khả kháng sẽ không phải bồi thường thiệt hại, bị phạt hoặc
                    bị chấm dứt Hợp Đồng. Tuy nhiên, nếu Bên gặp phải sự kiện
                    bất khả kháng không nỗ lực đến mức tối đa để thực hiện Hợp
                    Đồng và khắc phục hoặc hạn chế thiệt hại xảy ra thì vẫn bị
                    coi là vi phạm Hợp Đồng.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='9. XÁC NHẬN CỦA HAI BÊN' key='9'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.1. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Các Bên đảm bảo có đầy đủ thẩm quyền để ký Hợp Đồng này và
                    có đủ năng lực để thực hiện các nghĩa vụ của mình tại Hợp
                    Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.2. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không có quy định nào trong Hợp Đồng này, khẳng định hoặc
                    ngụ ý rằng, Chương Trình Tiếp Thị Liên Kết là độc quyền của
                    mỗi Bên.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.3. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Trong trường hợp, VNTRAVEL có trách nhiệm pháp lý với Đối
                    Tác Liên Kết, thì trách nhiệm pháp lý đó sẽ được giới hạn
                    trong tổng số tiền Hoa Hồng mà VNTRAVEL phải thanh toán cho
                    Đối Tác Liên Kết vào tháng liền trước tháng xảy ra vi phạm
                    của VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.4. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Trong trường hợp có khiếu nại của bên thứ ba, Hai Bên sẽ
                    cùng hợp tác và hỗ trợ Bên còn lại để giải quyết các khiếu
                    nại này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.5.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Dữ Liệu Khách Hàng thuộc quyền sở hữu và sử dụng hợp pháp
                    của VNTRAVEL. Đối Tác Liên Kết sẽ không thực hiện bất kỳ
                    hành vi nào, bao gồm nhưng không giới hạn ở: sử dụng, cho
                    phép sử dụng, sửa chữa, thay đổi Dữ Liệu Khách Hàng nếu
                    không được sự đồng ý của VNTRAVEL.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.6.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL có quyền sửa đổi, bổ sung Hợp Đồng này vào bất kỳ
                    thời điểm nào và Đối Tác Liên Kết có trách nhiệm thường
                    xuyên theo dõi nội dung của Hợp Đồng. Việc Đối Tác Liên Kết
                    tiếp tục truy cập, sử dụng Tài Khoản Liên Kết và cung cấp
                    dịch vụ tiếp thị liên kết cho VNTRAVEL được hiểu là Đối Tác
                    Liên Kết đã đồng ý với các điều khoản và điều kiện của Hợp
                    Đồng này tại từng thời điểm.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 9.7.</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Hợp Đồng này tạo thành một thỏa thuận có giá trị pháp lý
                    ràng buộc Hai Bên. Các Bên đồng ý rằng Hợp Đồng này có giá
                    trị pháp lý ràng buộc Hai Bên từ thời điểm Đối Tác Liên Kết
                    hoàn thành Đơn Đăng Ký.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
          <Panel header='10. CÁC QUY ĐỊNH CHUNG' key='10'>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 10.1 </div>
                </Col>
                <Col span={21}>
                  <div className='right'>Chấm dứt Hợp Đồng</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> a)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Các trường hợp chấm dứt Hợp Đồng:
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    VNTRAVEL quyết định chấm dứt Chương Trình Tiếp Thị Liên Kết.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Tài Khoản Liên Kết của Đối Tác Liên Kết bị khóa do vi phạm
                    quy định tại Hợp Đồng này.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> b)</div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>Việc chấm dứt Hợp Đồng sẽ:</div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (i) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không ảnh hưởng tới sự tồn tại của bất kỳ nghĩa vụ nào đã
                    phát sinh hoặc ở hiện tại liên quan tới việc thanh toán;
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left-normal'> (ii) </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Không ảnh hưởng tới hiệu lực của các điều khoản quy định về
                    nghĩa vụ bảo mật thông tin.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 10.2. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Nếu bất kỳ phần nào, điều khoản hoặc điều kiện nào của Hợp
                    Đồng này bị cơ quan có thẩm quyền tuyên bố là bất hợp pháp
                    hoặc không thể thi hành, thì không ảnh hưởng tới tính hiệu
                    lực hoặc khả năng thi hành của các điều khoản còn lại của
                    Hợp Đồng.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 10.3. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Luật áp dụng cho việc ký kết và thực hiện hợp đồng là Pháp
                    luật của nước Cộng Hoà Xã Hội Chủ Nghĩa Việt Nam.
                  </div>
                </Col>
              </Row>
            </div>
            <div className='content'>
              <Row>
                <Col span={3}>
                  <div className='left'> 10.4. </div>
                </Col>
                <Col span={21}>
                  <div className='right-normal'>
                    Mọi tranh chấp phát sinh từ hoặc liên quan đến Hợp Đồng này
                    sẽ được giải quyết bằng trọng tài tại Trung tâm Trọng tài
                    Quốc tế Việt Nam (VIAC) theo Quy tắc tố tụng trọng tài của
                    Trung tâm này. Địa điểm trọng tài là Hà Nội.
                  </div>
                </Col>
              </Row>
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default MobilePolicy;
